module.exports = __webpack_public_path__ + "src/img/artist/work03_2.jpg?99b70188a8d180e2346a97ab40863682";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/work03_2.jpg
// module id = 151
// module chunks = 0